import { Box, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget, ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allUsuariosAction, setActivoUsuariosAction } from './UsuariosAction';
import FiltrosUsuariosComponent from './components/FiltrosUsuarios';
import FormNuevoUsuariosComponent from './components/FormNuevoUsuarios';
import ListadoUsuarios from './components/ListadoUsuarios';
import TabsInfoUsuariosComponent from './components/TabsInfoUsuarios';

const UsuariosModule = ({ all }) => {
  const dispatch = Redux.useDispatch();
  const usuariosStore = Redux.useSelector((state) => state.usuarios);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isFiltros, setFiltros] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          {!usuariosStore.isAllOnEDU && (
            <BotonComponent
              click={() => {
                setActivoUsuariosAction(dispatch, null);
                setOpenModalForm(true);
              }}
              green
              mr={2}
              addIcon
            />
          )}
          {usuariosStore.all.length > 0 && (
            <BotonComponent
              click={async () => {
                await allUsuariosAction(dispatch, usuariosStore.params);
              }}
              white
              refreshIcon
              disabled={usuariosStore.loadingAll}
              text={usuariosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
            />
          )}
        </Box>
        <Box>
          <BotonComponent
            text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
            filterIcon
            click={() => setFiltros(true)}
            white={!isFiltros}
            blue={isFiltros}
            mr={1}
          />
        </Box>
      </Grid>
      <Grid item md={12}>
        <ListadoUsuarios
          setOpenModalForm={(val) => setOpenModalForm(val)}
          all={all}
        />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setFiltros(val)}>
        <FiltrosUsuariosComponent />
      </DrawerWidget>
      <ModalComponent
        id="modalFormUsuarios"
        title={
          usuariosStore.activo
            ? `Editar: ${`${usuariosStore.activo?.perfil.pnombre} ${
                usuariosStore.activo?.perfil.snombre ?? ''
              } ${usuariosStore.activo?.perfil.papellido} ${
                usuariosStore.activo?.perfil.sapellido ?? ''
              }`.toUpperCase()}`
            : 'Nuevo usuario'
        }
        open={openModalForm}
        maxWidth="lg"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {usuariosStore.activo ? (
          <TabsInfoUsuariosComponent />
        ) : (
          <FormNuevoUsuariosComponent
            setOpenModalForm={(val) => setOpenModalForm(val)}
          />
        )}
      </ModalComponent>
    </Grid>
  );
};

export default UsuariosModule;
